<template>
  <TransferListBox :api="postTransferLog" />
</template>
<script>
import { postTransferLog } from '@/api/user'

import TransferListBox from '../../components/TransferListBox.vue'

export default {
  name: 'UserTransferList',
  components: { TransferListBox },
  data() {
    return {
      postTransferLog
    }
  },
  watch: {},
  created() {},
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/user/transferlist.vue